import { Modal, Typography, Divider, Tag, Image, Breadcrumb } from "antd";
import { ArrowLeftOutlined, CalendarOutlined, FilePdfOutlined } from "@ant-design/icons";

const { Title, Paragraph, Text } = Typography;

export default function SingleAnnouncement({ singleData, onBack }) {
    const formatDate = (dateString) => {
        const date = new Date(dateString);
        return date.toLocaleDateString("en-US", {
            month: "short",
            day: "numeric",
            year: "numeric",
        });
    };

    return (
        <Modal
            open={!!singleData}
            onCancel={onBack}
            footer={null}
            width={1000}
            centered
            bodyStyle={{
                borderRadius: 12,
                padding: 24,
                // boxShadow: "0 8px 30px rgba(0,0,0,0.2)", // strong elevation
            }}
            style={{ top: 20 }}
        >
            {/* Breadcrumb */}
            <Breadcrumb
                style={{ marginBottom: 16 }}
                items={[
                    {
                        title: (
                            <span
                                style={{ cursor: "pointer", color: "#0e497b" }}
                                onClick={onBack}
                            >
                                <ArrowLeftOutlined /> Back
                            </span>
                        ),
                    },
                    { title: "Announcement" },
                ]}
            />

            {/* Title */}
            <Title level={4} style={{ marginBottom: 8, color: "#0e497b" }}>
                {singleData.title}
            </Title>

            {/* File preview */}
            {singleData.announcement_file && (
                <center style={{ marginTop: 16 }}>
                    {/\.(jpg|jpeg|png|gif|bmp|webp)$/i.test(singleData.announcement_file) ? (
                        <Image
                            src={singleData.announcement_file}
                            style={{ width: "300px", height: "200px", borderRadius: "20px" }}
                        />
                    ) : singleData.announcement_file ? (
                        <a
                            href={singleData.announcement_file}
                            download
                            style={{
                                display: "inline-block",
                                backgroundColor: "white",
                                border: "1px solid #ffffff",
                                borderRadius: "8px",
                                padding: "12px 16px",
                                textAlign: "center",
                                cursor: "pointer",
                                textDecoration: "none",
                            }}
                        >
                            <FilePdfOutlined style={{ fontSize: 64, color: "red" }} />
                            <div style={{ marginTop: 8, color: "#0e497b" }}>Download PDF</div>
                        </a>
                    ) : (
                        <div style={{ color: "gray" }}>Unsupported file format</div>
                    )}
                </center>
            )}

            {/* Meta info */}
            <div
                style={{
                    display: "flex",
                    alignItems: "center",
                    marginBottom: 16,
                    gap: 8,
                    marginTop: 16,
                }}
            >
                <CalendarOutlined style={{ color: "#999" }} />
                <Text type="secondary">{formatDate(singleData.created_at)}</Text>
                {singleData.isNew && <Tag color="red">New</Tag>}
            </div>

            <Divider style={{ margin: "12px 0" }} />

            {/* Content */}
            <Paragraph style={{ fontSize: "15px", lineHeight: 1.8, whiteSpace: "pre-line", marginBottom: 0 }}>
                {singleData.content}
            </Paragraph>
        </Modal>
    );
}
